import 'src/../../css/third_party/jquery-qTip/jquery.qtip.min.css';

import 'src/common/CommonPage.js';
import 'src/css/k1/login.scss';
